import { apiClient } from './api';
import { safeArray } from '../utils/money';
import { normalizeBalance } from './balance';
import {
  DashboardData,
  Balance,
  BalanceTransaction
} from '../types';

export class DashboardService {
  // 获取仪表盘数据
  static async getDashboardData(days: number = 30): Promise<DashboardData> {
    // Fixed: Backend endpoint is /merchant/dashboard not /dashboard/data
    const response = await apiClient.get('/merchant/dashboard', {
      params: { days }
    });
    // 后端返回 { summary:{...}, trends:{...}, recent_transactions:[], pending_items:{} }
    // 这里归一化为前端 DashboardData 扁平结构，缺失字段一律兜底为 0/[]，
    // 修复 “Cannot read properties of undefined (reading 'total_transactions')” 等崩溃。
    const env = response.data?.data ?? response.data ?? {};
    const summary = env.summary || {};
    const trends = env.trends || {};
    return {
      total_revenue: (summary.total_revenue ?? 0) / 100,
      revenue_trend: 0,
      total_orders: summary.total_transactions ?? 0,
      orders_trend: 0,
      total_payments: summary.total_transactions ?? 0,
      payments_trend: 0,
      success_rate: summary.success_rate ?? 0,
      success_rate_trend: 0,
      active_customers: summary.active_customers ?? 0,
      customers_trend: 0,
      recent_transactions: safeArray(env.recent_transactions),
      currency_breakdown: safeArray(trends.payment_methods),
      // 透传原始字段，方便图表使用
      ...(env as any),
      trends,
      summary,
    } as DashboardData;
  }

  // 获取仪表盘统计数据
  static async getDashboardStats(): Promise<any> {
    const response = await apiClient.get('/merchant/stats');
    return response.data;
  }

  // 获取余额信息
  static async getBalance(): Promise<Balance> {
    // Fixed: Backend endpoint is /merchant/balance not /dashboard/balance
    const response = await apiClient.get('/merchant/balance');
    // 后端实际返回币种->金额映射（如 { USD: 941 }），统一归一化处理。
    return normalizeBalance(response.data?.data ?? response.data);
  }

  // Note: /merchant/dashboard/charts endpoint not available in backend
  // Use transaction reports instead: /merchant/payments/reports/transactions
  // static async getTransactionCharts(period?: string, currency?: string): Promise<any> {
  //   const response = await apiClient.get('/dashboard/charts', {
  //     params: { period, currency }
  //   });
  //   return response.data;
  // }

  // 获取余额历史
  static async getBalanceHistory(days: number = 30): Promise<BalanceTransaction[]> {
    // Fixed: Backend endpoint is /merchant/balance/history not /dashboard/balance/history
    const response = await apiClient.get('/merchant/balance/history', {
      params: { days }
    });
    return safeArray<BalanceTransaction>(response.data?.data ?? response.data);
  }

  // 获取仪表盘统计数据（兜底）
  static async getDashboardStatsSafe(): Promise<any> {
    const response = await apiClient.get('/merchant/stats');
    return response.data?.data ?? response.data ?? {};
  }
} 